<template>
  <v-dialog
    v-model="active"
    persistent
    max-width="420">
    <v-card>
      <v-card-title class="headline">
        {{ title ? $t(`modal.${title}`) : '' }}
      </v-card-title>
      <v-card-text>
        <p class="white-space-pre">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="message ? $t(`modal.${message}`) : ''"></span>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!confirmOnly"
          color="error"
          text
          @click="cancel">
          {{ cancelText ? $t(`modal.${cancelText}`) : '' }}
        </v-btn>
        <v-btn
          :color="confirmOnly ? confirmType : 'success'"
          text
          @click="confirm">
          {{ confirmText ? $t(`modal.${confirmText}`) : '' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false
    },
    confirmText: {
      type: String,
      required: false,
      default: 'Agree'
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Disagree'
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    confirmOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    confirmType: {
      type: String,
      required: false,
      default: 'success'
    }
  },
  methods: {
    confirm () {
      this.$emit('update:active', false)
      this.$emit('onConfirm', true)
    },
    cancel () {
      this.$emit('update:active', false)
      this.$emit('onCancel', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .white-space-pre>* {
    white-space: pre;
  }
</style>
